/* @flow */
import { PRODUCT_CHANGE } from '../../../ActionsConst';

export const productChange = (id: string, obj: {}) => ({
  type: PRODUCT_CHANGE,
  id,
  obj,
});
